import { registerAwsDelegate } from "@p0security/integrations-aws-shared/delegates";
import { AwsIconUrl } from "@p0security/integrations-aws-shared/icon";
import { registerIntegration } from "@p0security/shared/integrations/registry";
import {
  type AnyFilterSchema,
  Registration,
} from "@p0security/shared/integrations/types";
import { Delegate } from "@p0security/shared/types/access/index";

import { AwsMidcAccesses } from "./accesses.ts";
import { AwsMidcComponents } from "./components.ts";

const AwsMidcFilters = {} as const satisfies AnyFilterSchema;
export type AwsMidcFilters = typeof AwsMidcFilters;

export const AwsMidcRegistration = Registration({
  accesses: AwsMidcAccesses,
  category: "resource",
  components: AwsMidcComponents,
  docs: {
    install: "aws",
  },
  filters: AwsMidcFilters,
  identifier: "AWS account ID",
  itemKind: "account",
  label: "AWS MIDC",
  logoUrl: AwsIconUrl,
  maturity: "ga",
  requestType: "bridge",
  useMapping: [{ use: "iam_write", component: "identity" }],
});

registerIntegration("aws-midc", AwsMidcRegistration);

// Populates `aws`'s "policy" and "resource" delegates records with
// `aws-midc`'s own accesses -- see `../aws/delegates.ts`'s doc comment for
// why `aws/accesses.ts` doesn't import `AwsMidcAccesses` directly.
registerAwsDelegate(
  "policy",
  "aws-midc",
  Delegate({ resource: "aws-midc", accesses: AwsMidcAccesses, key: "policy" })
);
registerAwsDelegate(
  "resource",
  "aws-midc",
  Delegate({
    resource: "aws-midc",
    accesses: AwsMidcAccesses,
    key: "resource",
  })
);
